var _path, _rect, _path2, _path3, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateRangeDuotoneDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 8.33333C2.5 7.08718 2.5 6.4641 2.76795 6C2.94349 5.69596 3.19596 5.44349 3.5 5.26795C3.9641 5 4.58718 5 5.83333 5H14.1667C15.4128 5 16.0359 5 16.5 5.26795C16.804 5.44349 17.0565 5.69596 17.2321 6C17.5 6.4641 17.5 7.08718 17.5 8.33333H2.5Z",
    fill: "#BCBCBC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 5,
    width: 15,
    height: 12.5,
    rx: 2,
    stroke: "#BCBCBC",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8335 2.5L5.8335 5",
    stroke: "#BCBCBC",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 2.5L14.1665 5",
    stroke: "#BCBCBC",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.8335,
    y: 10,
    width: 3.33333,
    height: 1.66667,
    rx: 0.5,
    fill: "#BCBCBC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.8335,
    y: 13.3334,
    width: 3.33333,
    height: 1.66667,
    rx: 0.5,
    fill: "#BCBCBC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8335,
    y: 10,
    width: 3.33333,
    height: 1.66667,
    rx: 0.5,
    fill: "#BCBCBC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8335,
    y: 13.3334,
    width: 3.33333,
    height: 1.66667,
    rx: 0.5,
    fill: "#BCBCBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateRangeDuotoneDark);
export default __webpack_public_path__ + "static/media/Date_range_duotone_dark.a1d98801955a3514e7cdb29f73bf89ea.svg";
export { ForwardRef as ReactComponent };